import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";
import VueAxios from "vue-axios";

import config from "./config";

Vue.use(Vuex);
Vue.use(VueAxios, Axios);

export default new Vuex.Store({
  state: {
    pages: [],
    apiParams: {
      per_page: 10,
      order: 'asc',
      orderby : 'menu_order',
      page: 1,
      offset: 0,
      _embed: true
    },
  },
  mutations: {
    GET_PAGES(state, pages) {
      state.pages = pages;
    }
  },
  actions: {
    loadPages({ commit }) {
      Axios.get(config.pages, { params: this.state.apiParams })
        .then(response => response.data)
        .then(pages => {
          commit("GET_PAGES", pages);
        });
    }
  }
});
